import React from 'react'
import { Dialog, DialogContent, DialogTitle, Typography } from '@material-ui/core'
import Button from 'UI/Button/ButtonWithPreloader'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: 12,
      minWidth: 600,
      maxWidth: 800,
    },
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2, 3),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  dialogContent: {
    padding: theme.spacing(3),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    gap: theme.spacing(2),
  },
  cancelButton: {
    width: '45%',
  },
  saveButton: {
    width: '45%',
  },
}))

interface ClawbackFormProps {
  open: boolean
  onClose: () => void
  onSubmit: () => void
  type: 'Rep' | 'ISO'
  isLoading?: boolean
}

const ClawbackForm: React.FC<ClawbackFormProps> = ({
  open,
  onClose,
  onSubmit,
  type,
  isLoading = false,
}) => {
  const classes = useStyles()

  return (
    <Dialog open={open} onClose={onClose} className={classes.dialog}>
      <DialogTitle className={classes.dialogTitle}>
        <Typography variant="h6">{type} Clawback</Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <div className={classes.buttonContainer}>
          <Button onClick={onClose} color="secondary" variant="contained" className={classes.cancelButton}>
            Cancel
          </Button>
          <Button onClick={onSubmit} color="primary" variant="contained" disabled={isLoading} className={classes.saveButton}>
            {isLoading ? 'Processing...' : 'Send Now'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ClawbackForm
